import { useLocation } from 'react-router-dom'
import useAuth from '../../hooks/useAuth'

const TopBar = () => {
	const location = useLocation()

	const { logOut } = useAuth()

	if (location.pathname === '/login' || location.pathname === '/') {
		return false
	}

	const handleLogout = () => {
		logOut()
	}

	return (
		<div className='topbar text-end'>
			<button className='btn btn-danger' onClick={handleLogout}>
				Log Out
			</button>
		</div>
	)
}

export default TopBar
